
import { defineComponent } from 'vue';
import { PhArrowCircleRight, PhArrowLeft, PhCloudArrowDown, PhDownload } from '@phosphor-icons/vue';

export default defineComponent({
    name: 'ShareMethodScreen',
    components: { PhArrowCircleRight, PhArrowLeft, PhCloudArrowDown, PhDownload },
    emits: ['back'],
    data() {
        return {
            customBg: require('../../../../assets/images/signup-v2/custom-ditto-bg.jpg'),
            strideLogo: require('../../../../assets/images/signup-v2/strideux-logo.svg')
        };
    }
});
